import { Alert, Button } from 'antd'

export const ServiceLocationReadError = ({ isError, retry }: { isError: boolean; retry: () => unknown }) =>
  isError ? (
    <Alert
      type="error"
      message="Unable to load service location"
      action={
        <Button size="small" onClick={() => retry()}>
          Retry
        </Button>
      }
    />
  ) : null
